import React, { useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom'; 
import Header from '../../../components/Layout/Header';
import Sidebar from '../../../components/Layout/Sidebar';
import Footer from '../../../components/Layout/Footer';

const Authorized = () => {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

    const sidebarWidth = "280px";
    const sidebarCollapsedWidth = "80px";
    const currentSidebarWidth = isSidebarCollapsed ? sidebarCollapsedWidth : sidebarWidth;

    return (
        <Flex>
            <Sidebar
                isCollapsed={isSidebarCollapsed}
                onToggle={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
            />

            <Box
                flex="1"
                ml={currentSidebarWidth}
                transition="margin-left 0.3s ease-in-out"
                w={`calc(100% - ${currentSidebarWidth})`}
                h="100vh"
                display="flex"
                flexDirection="column"
            >
                <Header />

                <Box as="main" flex="1" p={8} overflowY="auto">
                    <Outlet />
                </Box>
                
                <Footer />
            </Box>
        </Flex>
    );
};

export default Authorized;